export const SET_ACTIVE_MENU_ITEM = "SET_ACTIVE_MENU_ITEM";
export const SET_ACTIVE_MENU_TRAIL = "SET_ACTIVE_MENU_TRAIL";
export const SET_USER = "SET_USER";
export const ADD_MENU_ITEMS = "ADD_MENU_ITEMS";
